import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { SwiperSlide } from "swiper/react";
import { HeroContent } from "../../components/HeroV2/HeroContent";
import { SwiperJti } from "../../components/SwiperJti";
import { useCurrentBreakpoint } from "../../hooks/useCurrentBreakpoint";
import { useUser } from "../../hooks/useUser";
import { HeroBackground } from "./HeroBackground/HeroBackground";
import { buildHeroContent } from "./utils/buildHeroContent";
import { Promotions } from "./Promotions";
import styles from "./HeroContentAuthoringWrapper/HeroContentAuthoringWrapper.module.scss";
export const HeroV2 = ({ data = [], isContainerWidth = false, isViewportHeight = true, withLoader = false, theme = "dark", }) => {
    const { isUserLoggedIn } = useUser();
    const promoRefs = useRef([]);
    const [promoHeights, setPromoHeights] = useState([]);
    const [currentSlide, setCurrentSlide] = useState(0);
    const { specificBreakpoint } = useCurrentBreakpoint();
    const recalculateHeight = useCallback(() => {
        const newPromoHeights = promoRefs.current.map((promoRef) => promoRef?.offsetHeight || 0);
        setPromoHeights(newPromoHeights);
    }, [setPromoHeights]);
    useEffect(() => {
        recalculateHeight();
        window.addEventListener("resize", recalculateHeight);
        return () => window.removeEventListener("resize", recalculateHeight);
    }, [data, recalculateHeight]);
    const handleSlideChange = useCallback((swiper) => {
        setCurrentSlide(swiper.realIndex);
    }, [setCurrentSlide]);
    useEffect(() => {
        const pagination = document.querySelector(".swiper-pagination-bullets");
        // basic bottom value from layouts;
        let bottom = 28;
        if (pagination && Boolean(promoHeights[currentSlide])) {
            bottom += promoHeights[currentSlide];
        }
        pagination.style.bottom = `${bottom}px`;
    }, [promoHeights, currentSlide, specificBreakpoint]);
    const [isVideoLoaded, setIsVideoLoaded] = useState(false);
    const isFirstElementVideo = data[0]?.backgroundType === "video";
    const showLoader = withLoader && !isVideoLoaded && isFirstElementVideo;
    return (_jsx(_Fragment, { children: _jsx(SwiperJti, { isViewportHeight: isViewportHeight, isCustomPagination: true, loop: true, isContainerWidth: isContainerWidth, handleSlideChange: handleSlideChange, showLoader: showLoader, isShowNavigationArrows: data.length > 1, children: data.map((slide, index) => {
                const discounts = slide?.content?.discounts;
                const hasDiscounts = discounts && discounts.length > 0;
                const isFirstElement = index === 0 && isFirstElementVideo;
                return (_jsx(SwiperSlide, { children: _jsxs(_Fragment, { children: [_jsx(HeroBackground, { backgroundType: slide.backgroundType, desktopImage: slide.desktopImage, mediumImage: slide.mediumImage, smallImage: slide.smallImage, tabletVideoFileReference: slide.tabletVideoFileReference, mobileVideoFileReference: slide.mobileVideoFileReference, videoFileReference: slide.videoFileReference, removeVideoRoundedCorners: slide.removeVideoRoundedCorners, renderBackgroundImage: slide.renderBackgroundImage, setIsVideoLoaded: setIsVideoLoaded, isFirstElement: isFirstElement }), _jsxs("div", { className: classNames(styles.content, {
                                    [styles.contentContainerWidth]: isContainerWidth,
                                    [styles.contentContainerWidthWithPromotions]: isContainerWidth && hasDiscounts,
                                }), children: [_jsx(HeroContent, { ...buildHeroContent(slide, isUserLoggedIn, isContainerWidth), theme: theme }), _jsx("div", { className: styles.bottom, children: (hasDiscounts || slide.legalDisclaimer) && (_jsx(Promotions, { discounts: discounts, legalDisclaimer: slide.legalDisclaimer, ref: (el) => (promoRefs.current[index] = el) })) })] })] }) }, `${slide.content?.title}--${index}`));
            }) }) }));
};
//# sourceMappingURL=HeroV2.js.map